import React, { useMemo } from 'react'
import Tree from 'rc-tree'
import PropTypes from 'prop-types'
import { Global } from '@emotion/react'
import { styles } from './styled'

const RenderTree = function (props) {
  const {
    ckey,
    label,
    children,
    data,
    className,
    setExtData,
    showLine,
    showIcon,
    onSelect,
    onCheck,
    defaultExpandedKeys,
    defaultSelectedKeys,
    multiple,
    checkable,
    height,
    icon,
    otherTitle = () => '',
    titleRender,
    titleLength,
    ...otherProps
  } = props

  const renderTitle = (item, index) => {
    if (typeof titleRender === 'function') return titleRender(item, index)

    return (
      <div className="flex items-center">
        <div title={item[label]}>
          {titleLength && item[label].length > titleLength
            ? `${item[label].slice(0, titleLength)}...`
            : item[label]}
        </div>
        <div>{otherTitle(item)}</div>
      </div>
    )
  }

  const treeData = useMemo(() => {
    const gen = (item, index) => {
      const node = {
        ...item,
        key: item[ckey],
        title: renderTitle(item, index),
        extData: setExtData(item),
        icon: icon(item),
      }
      if (item[children] && item[children].length > 0) {
        node.children = item[children].map(gen)
      }
      return node
    }

    return data.map(gen)
  }, [data, titleRender])

  return (
    <>
      <Global styles={styles} />
      <Tree
        multiple={multiple}
        checkable={checkable}
        showLine={showLine}
        onSelect={(_key, node) => {
          onSelect(_key, node)
        }}
        showIcon={showIcon}
        onCheck={(_key, node) => {
          onCheck(_key, node)
        }}
        titleLength={titleLength}
        defaultExpandedKeys={defaultExpandedKeys}
        defaultSelectedKeys={defaultSelectedKeys}
        height="100%"
        treeData={treeData}
        {...otherProps}
      />
    </>
  )
}
RenderTree.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  className: PropTypes.string,
  ckey: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.string,
  setExtData: PropTypes.func,
  showLine: PropTypes.bool,
  showIcon: PropTypes.bool,
  onSelect: PropTypes.func,
  onCheck: PropTypes.func,
  defaultExpandedKeys: PropTypes.arrayOf(PropTypes.string),
  defaultSelectedKeys: PropTypes.arrayOf(PropTypes.string),
  multiple: PropTypes.bool,
  checkable: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  icon: PropTypes.func,
  otherProps: PropTypes.shape({}),
  titleLength: PropTypes.number,
}

RenderTree.defaultProps = {
  className: '',
  ckey: 'key',
  label: 'label',
  children: 'children',
  setExtData: () => {},
  showLine: true,
  showIcon: true,
  onSelect: () => {},
  onCheck: () => {},
  defaultExpandedKeys: [],
  defaultSelectedKeys: [],
  multiple: false,
  checkable: false,
  height: undefined,
  icon: () => null,
  otherProps: {},
  titleLength: null,
}

export default RenderTree
